/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the home page
    // add the current cart total to the cart button in the main nav
    const $doc = $(document);
    const $win = $(window);

    $('.featured-articles__wrapper').append('<div class="loading-icon" style="width:100%;height:120px;position:relative;"><i class="far fa-spinner fa-pulse fa-2x" style="position:absolute;top:50%;color:#696060;left:50%;transform:translate3d(-50%,-50%,0);"></i></div>');


    $win.on('load', () => {
      $('.featured-articles__container').css({"opacity":"1", "height":"auto"});
      if ( $('.loading-icon').length ) {
        $('.loading-icon').fadeOut(200).remove();
      }
    });

    // matchHeight.js
    $(() => {
      $('.featured__post-content-wrapper').matchHeight();
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js